// extracted by mini-css-extract-plugin
export var quantityInput = "_fl-0";